/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthorResponsePage } from '../../models/author-response-page';

export interface ListAuthors$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'surname' | '-surname' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listAuthors(http: HttpClient, rootUrl: string, params?: ListAuthors$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthorResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listAuthors.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthorResponsePage>;
    })
  );
}

listAuthors.PATH = '/v0/authors';
